"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPusherClient = void 0;

var tslib_1 = require("tslib");

var dashboard_constants_1 = require("@hopin-team/dashboard-constants");

var pusher_js_1 = (0, tslib_1.__importDefault)(require("pusher-js"));

function fetchPusherCredentials() {
  return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
    var url, response, credentials;
    return (0, tslib_1.__generator)(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = "".concat((0, dashboard_constants_1.getBaseUrl)(), "/api/v2/pusher/credentials");
          return [4
          /*yield*/
          , fetch(url, {
            method: 'GET'
          })];

        case 1:
          response = _a.sent();
          return [4
          /*yield*/
          , response.json()];

        case 2:
          credentials = _a.sent().credentials;

          if (!credentials) {
            throw new Error('No credentials received');
          }

          return [2
          /*return*/
          , credentials];
      }
    });
  });
}

function getStaticPusherCredentials() {
  return {
    key: (0, dashboard_constants_1.getPusherKey)(),
    cluster: (0, dashboard_constants_1.getPusherCluster)()
  };
}

function getPusherCredentials() {
  return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
    return (0, tslib_1.__generator)(this, function (_a) {
      if ((0, dashboard_constants_1.getPusherFetchCredentialsFromApi)() === 'true') {
        try {
          return [2
          /*return*/
          , fetchPusherCredentials()];
        } catch (error) {
          console.error(error);
          console.log('Unable to fetch Pusher credentials from the server');
        }
      }

      return [2
      /*return*/
      , getStaticPusherCredentials()];
    });
  });
}

function createPusherClient(_a) {
  var authToken = _a.authToken;
  return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
    var credentials;
    return (0, tslib_1.__generator)(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , getPusherCredentials()];

        case 1:
          credentials = _b.sent();
          return [2
          /*return*/
          , new pusher_js_1.default(credentials.key, {
            cluster: credentials.cluster,
            authEndpoint: (0, dashboard_constants_1.getPusherAuthUrl)(),
            auth: {
              headers: {
                Authorization: "Bearer ".concat(authToken)
              }
            }
          })];
      }
    });
  });
}

exports.createPusherClient = createPusherClient;